"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const TextFilter_styles_1 = require("./TextFilter.styles");
const styles_1 = require("../styles");
const TextFilter = ({ column, showLabel = false, tableId, isLoading = false }) => {
    const { filterValue, setFilter, id, render, filterLabel } = column;
    const inputInfo = (typeof filterLabel === 'string' && filterLabel) ||
        `Filter by ${render('Header')}`;
    const filterLabelId = `filter-input-label-${tableId}-${id}`;
    const filterId = `filter-input-${tableId}-${id}`;
    return (react_1.default.createElement("span", { role: "presentation", onClick: (e) => {
            e.stopPropagation();
        } },
        showLabel ? (react_1.default.createElement(styles_1.FilterLabel, { id: filterLabelId, htmlFor: filterId }, inputInfo)) : (react_1.default.createElement(styles_1.HiddenFilterLabel, { id: filterLabelId, htmlFor: filterId }, inputInfo)),
        react_1.default.createElement(TextFilter_styles_1.FilterInput, { "data-testid": "text-filter", id: filterId, disabled: isLoading, name: filterId, "aria-labelledby": filterLabelId, value: filterValue || '', onChange: (e) => {
                setFilter(e.target.value || undefined);
            }, title: inputInfo, placeholder: inputInfo })));
};
exports.default = TextFilter;
//# sourceMappingURL=TextFilter.js.map